import { apiRequest } from '../api/apiClient';

const BASE = '/api/v2/training';

export async function fetchTrainingCurriculum() {
  return apiRequest(`${BASE}/curriculum`);
}

export async function fetchTrainingLesson(procedureId) {
  return apiRequest(`${BASE}/lessons/${encodeURIComponent(procedureId)}`);
}

export async function fetchTrainingProgress() {
  return apiRequest(`${BASE}/progress`);
}

export async function patchTrainingProgress(body) {
  // apiRequest JSON.stringifies `body` — pass a plain object, never a pre-stringified payload.
  return apiRequest(`${BASE}/progress`, {
    method: 'PATCH',
    body,
  });
}

export async function startLesson(procedureId) {
  return patchTrainingProgress({ action: 'start_lesson', procedureId });
}

export async function nextLessonStep(procedureId) {
  return patchTrainingProgress({ action: 'next_step', procedureId });
}

export async function previousLessonStep(procedureId) {
  return patchTrainingProgress({ action: 'previous_step', procedureId });
}

export async function finishLesson(procedureId) {
  return patchTrainingProgress({ action: 'finish_lesson', procedureId });
}

export async function resolveOnDemandTraining(query) {
  return apiRequest(`${BASE}/on-demand`, {
    method: 'POST',
    body: { query },
  });
}

export async function startOnDemandTraining({ scenarioId, title, procedureIds }) {
  return patchTrainingProgress({
    action: 'start_on_demand',
    scenarioId,
    title,
    procedureIds,
  });
}

export async function personalizeLesson(procedureId) {
  return apiRequest(`${BASE}/lessons/${encodeURIComponent(procedureId)}/personalize`, {
    method: 'POST',
    body: {},
  });
}
